import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {AsyncTypeahead as AsyncT} from 'react-bootstrap-typeahead';

import TooltipValidator from './TooltipValidator.jsx';

import './AsyncTypeahead.scss';

let it = 0;

export default class AsyncTypeahead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      options: []
    };
  }

  static propTypes = {
    ...AsyncT.propTypes,
    isLoading: PropTypes.bool,
    onSearch: PropTypes.func.isRequired,
    promptText: PropTypes.string,
  };

  static defaultProps = {
    ...AsyncT.defaultProps,
    emptyLabel: 'Aucun résultats n\'a été trouvé',
    searchText: 'Recherche en cours...',
    promptText: 'Commencez a écrire...',
    newSelectionPrefix: 'Créer une nouvelle entrée : ',
    valueField: null
  };

  render() {
    const { onSearch, isLoading, input, selectHintOnEnter, options, ...field } = this.props;

    const name = 'ita' + (input.name || it++);
    let classes = field.className || '';
    if (field.meta.visited || !field.meta.pristine || field.meta.submitFailed) {
      if (field.meta.valid) {
        classes += ' is-valid';
      } else {
        classes += ' is-invalid';
      }
    }

    if (!this.props.multiple) {
      classes += ' single-field';
    }

    const id = (field.id ? field.id : `${field.meta.form}_${name}`).replace('.', '_');

    return <div className="form-group" id={`${id}_container`}>
      { field.label && <label className="form-label" htmlFor={id}>{field.label}</label> }
      <TooltipValidator field={field} target={`${id}_container .rbt-input`} />
      <AsyncT
        {...field}
        id={`${id}-typeahead`}
        className={classes}
        onChange={this.onChange}
        inputProps={ { name, id } }
        onSearch={this.handleSearch}
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        options={this.state.options}
        isLoading={!!this.state.loading}
        filterBy={this.props.filterBy ? this.props.filterBy : (option, props) => {
          return true;
        }}
        selectHintOnEnter={this.props.selectHintOnEnter || true} />
      {field.children}
    </div>;
  }

  onFocus = () => {
    return this.props.input.onFocus();
  };

  onBlur = () => {
    return this.props.input.onBlur();
  };

  onChange = (val) => {
    if (this.props.customOnChange) {
      setTimeout(() => {
        this.props.customOnChange();
      }, 0)
    }
    
    for (let i = 0; i < val.length; i++) {
      if (val[i].customOption) {
        val[i].id = null;
      }
    }
    const callback = this.props.input.onChange;
    if (!this.props.valueField) {
      return callback(val);
    }

    if (typeof this.props.valueField === 'function') {
      return callback(this.props.valueField(val));
    }

    if (!this.props.multiple) {
      return callback(val?.[this.props.valueField] ?? null);
    }

    const values = val.map((el) => {
      return el?.[this.props.valueField] ?? null;
    });

    return callback(values);
  };

  handleSearch = async (query) => {
    this.setState({loading: true});
    try {
      const results = await this.props.onSearch(query);
      this.setState({ options: results });
    } catch(e) {
      console.warn('error', e);
      this.setState({ options: [] });
    } finally {
      this.setState({loading: false});
    }
  }
}
